export default __webpack_public_path__ + "static/b3-1de42597df7403f1688bce403d01c396.jpg";